module.exports = __webpack_public_path__ + "img/field-project-9.39277483.svg";